<div class="modal-header">
  <h4 class="modal-title">How to Setup MFA Device</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-1">
      <i class="fa fa-circle-1 fa-2x"></i>
    </div>
    <div class="col-11">
      Install application such as Google Authenticator, Duo Mobile, or Authy app on your mobile device or computer.
    </div>
  </div>
  <div class="row mt-20px">
    <div class="col-1">
      <i class="fa fa-circle-2 fa-2x"></i>
    </div>
    <div class="col-11">
      Open your authenticator app and scan the QR code.<br/>
      <img alt="code" src="{{qrCode}}"/>
    </div>
  </div>
  <div class="row mt-20px">
    <div class="col-1">
      <i class="fa fa-circle-3 fa-2x"></i>
    </div>
    <div class="col-11">
      Enter the code below.<br/>
      <div *ngIf="errorMessage" class="text-danger mb-2">{{ errorMessage }}</div>
      <form [formGroup]="valForm">
        <div class="row">
          <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
        </div>
      </form>
    </div>
  </div>
  <div class="row mt-20px">
    <div class="col-1">
      <i class="fa fa-circle-4 fa-2x"></i>
    </div>
    <div class="col-11">
      <button (click)="register()" [disabled]="code?.length<6" class="btn btn-dark wd-184px me-auto" type="button">
        Register
      </button>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-sm-flex  justify-content-between mt-4">
    <button (click)="cancel()" class="btn btn-outline-dark btn-lg wd-184px me-auto" type="button">Close</button>
  </div>
</div>
